import { render, staticRenderFns } from "./LiqForm.vue?vue&type=template&id=13ff466e&"
import script from "./LiqForm.vue?vue&type=script&lang=js&"
export * from "./LiqForm.vue?vue&type=script&lang=js&"
import style0 from "./LiqForm.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports